import type { SVGProps } from 'react';

const SvgBackInStock = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="m22.75 20.15-2.38-2.38-1.06 1.06 2.91 2.91a.75.75 0 0 0 1.06 0l8.37-8.33-1.06-1.07Z" />
      <path d="M28.45 18.23a5.6 5.6 0 0 1 .15 1.29 5.79 5.79 0 1 1-2.55-4.8l.84-1.24a7.29 7.29 0 1 0 3.21 6 6.8 6.8 0 0 0-.19-1.62Z" />
      <path d="M14 29.18V13l10.84-4.8v2.13h1.5V7.05a.74.74 0 0 0-.45-.68L13.54 1a.78.78 0 0 0-.6 0L.58 6.37a.75.75 0 0 0-.45.68v17.87a.73.73 0 0 0 .45.68L12.94 31a.7.7 0 0 0 .3.06.8.8 0 0 0 .3-.06l5.68-2.49-.6-1.37Zm-.75-17.54-4.7-2.05L19 5l4.69 2.05Zm0-9.17 3.92 1.71L6.68 8.77 2.75 7.05ZM1.63 8.2 12.49 13v16.18L1.63 24.43Z" />
    </g>
  </svg>
);

export default SvgBackInStock;
